import { render, staticRenderFns } from "./SimonSays.vue?vue&type=template&id=6040468f&"
import script from "./SimonSays.vue?vue&type=script&lang=js&"
export * from "./SimonSays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports